module.exports = __webpack_public_path__ + "img/rounded.f5846a51.svg";